import { Component } from '@angular/core';
import { DocMeta } from "@template-ui/decorators";
import { UiLibraryModule } from "@template-ui/template-ui.module";

@DocMeta({
  hide: true,
  showcaseTitle: "Simple outline group"
})
@Component({
    selector: 'ui-outlined-input-group-sample, ez-outlined-input-group-sample',
    imports: [UiLibraryModule],
    templateUrl: './outlined-input-group-sample.html',
    styleUrl: './outlined-input-group-sample.scss'
})
export class OutlinedInputGroupSample { }
